import { forwardRef, type Ref, type SVGProps } from "react";
const IconInitialsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M25 5.5a1.5 1.5 0 0 1 1.452 1.124l3.5 13.5a1.5 1.5 0 0 1-2.904.752L26.562 19h-3.123l-.487 1.876a1.5 1.5 0 0 1-2.904-.752l3.5-13.5A1.5 1.5 0 0 1 25 5.5m.784 10.5L25 12.977 24.217 16zM6.7 21.7c.4-.4.4-1 0-1.4l-.8-.8.8-.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-.8.8-.8-.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l.8.8-.8.8c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l.8-.8.8.8c.2.2.5.3.7.3s.5-.1.7-.3M4 24a2 2 0 1 0 0 4h24a2 2 0 1 0 0-4zM15.452 6.624a1.5 1.5 0 0 0-2.904 0l-3.5 13.5a1.5 1.5 0 1 0 2.904.752L12.44 19h3.123l.486 1.876a1.5 1.5 0 1 0 2.904-.752zM14.784 16h-1.567L14 12.977z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconInitialsFilledSVG);
ForwardRef.displayName = "IconInitialsFilled";
export { ForwardRef as IconInitialsFilled };
